import React from "react";
import Style from "./MoveProduct.module.css";
const MoveProduct = () => {
  return (
    <div className={Style.componentHolder}>
      <input className={Style.addressPart} placeholder={"آدرس مقصد"} />
      <input className={Style.addressPart} placeholder={"نام نام خانوادگی گیرنده"} />
      <input className={Style.addressPart} placeholder={"شماره تماس"} />
      <div className={Style.moveRuleHolder}>
        <h2 className={Style.rule}><sup>*</sup>حداکثر حجم کالا 40*40*40 می باشد</h2>
        <h2 className={Style.rule}><sup>*</sup>درصورتیکه حجم کالا بیشتر از حجم گفته شده باشد مبلغ پرداختی عودت داده نمی شود </h2>
        <h2 className={Style.rule}><sup>*</sup>سلامت کالای حمل شونده به عهده ی مشتری می باشد</h2>
      </div>
      <button className={Style.sendBtn}>
        ارسال درخواست
      </button>
    </div>
  );
};

export default MoveProduct;
